<template>
	<page style="background: #fff;">
		<c-form ref="form">
			<c-form-item label="反馈类型" required>
				<c-radio-group name="suggestion_type">
					<c-radio value="1">投诉</c-radio>
					<c-radio value="2">建议</c-radio>
				</c-radio-group>
			</c-form-item>
			<c-form-item label="反馈内容" required>
				<c-input type="textarea" name="feedback_content" placeholder="把反馈的问题详细说明一下...."></c-input>
			</c-form-item>
			<c-form-item label="上传图片">
				<c-upload-file name="feedback_images" :value="[]" media type="image" multiple="9"></c-upload-file>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		methods: {
			submitHandle() {
				this.$refs.form.submit({
					url: '/complaint/suggestion/add',
					rule: {
						suggestion_type: '请选择反馈类型',
						feedback_content: '请填写反馈内容'
					},
					success: () => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						setTimeout(() => {
							this.mp.navigateBack();
						}, 1000);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>